export default "/static/assets/mql.bea329ce358e02ec95544b4c0d4b5f58.svg";